import * as React from 'react';

import * as styles from './OffersStatsLayout.css';

export const OffersStatsLayout = (props: React.PropsWithChildren) => {
  return (
    <div className={styles['container']} data-testid="offers-stats-seo">
      {props.children}
    </div>
  );
};
